import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_MANAGE_ACCESS: MijnRoute = {
    path: 'persoon-toevoegen-verwijderen',
    navigationEvent: 'toManageAccess',
    regex: /^\/zelf-regelen\/persoon-toevoegen-verwijderen$/,
    webcomponent: 'mijn-klant-zelfservice-webcomponent',
    internalPath: '/persoon-toevoegen-verwijderen'
};
